import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword({ admin = false }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await api.post(admin ? "/admin/forgot-password" : "/auth/forgot-password", { email });
      setSent(true);
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-background p-6">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex justify-center"><Logo /></div>
        {sent ? (
          <div className="text-center space-y-3" data-testid="forgot-sent">
            <div className="mx-auto h-12 w-12 grid place-items-center rounded-full bg-brand-light text-brand"><MailCheck className="h-6 w-6" /></div>
            <h2 className="text-xl font-bold">Check your email</h2>
            <p className="text-sm text-muted-foreground">If an account exists for <b>{email}</b>, we've sent a password reset link. It expires in 1 hour.</p>
            <Link to={admin ? "/secure-admin/login" : "/login"} className="inline-block font-semibold text-brand hover:underline text-sm">Back to login</Link>
          </div>
        ) : (
          <>
            <h2 className="text-2xl font-bold tracking-tight text-center">Forgot password</h2>
            <p className="text-muted-foreground text-sm mt-1 mb-6 text-center">Enter your email and we'll send a reset link.</p>
            {err && <div className="mb-4 rounded-lg bg-rose-50 border border-rose-200 text-rose-700 text-sm px-3 py-2">{err}</div>}
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" />
              </div>
              <Button type="submit" disabled={loading} className="w-full h-11" data-testid="forgot-submit-button">
                {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} Send Reset Link
              </Button>
            </form>
            <p className="text-sm text-center text-muted-foreground mt-6">
              <Link to={admin ? "/secure-admin/login" : "/login"} className="font-semibold text-brand hover:underline">Back to login</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
